import { PublicLayout } from "@/components/layout/PublicLayout";
import { Reveal, SectionKicker } from "@/components/Reveal";
import SEO from "@/components/SEO";
import { container } from "@/lib/constants";

const STEPS = [
  ["01", "Application & verification", "You apply on behalf of a principal or vehicle. We verify status, jurisdiction, and standing before any deal is visible. Verification typically completes within two business days."],
  ["02", "Mandate submission", "You define your mandate — sectors, geographies, ticket size, and structure. This shapes everything we bring to you and nothing we don't."],
  ["03", "Deal matching & introduction", "Off-market opportunities are matched to your mandate. When there is genuine fit, we make a discreet introduction and open the relevant documentation under NDA."],
  ["04", "Execution support", "We coordinate introductions, manage information flow, and support diligence through to completion — quietly, and with both sides protected."],
];

export default function Process() {
  return (
    <PublicLayout>
      <SEO title="Process" description="A four-stage process: application and verification, mandate submission, deal matching and introduction, and execution support." />
      <section className={`${container} py-20 lg:py-24`}>
        <Reveal>
          <SectionKicker>How it works</SectionKicker>
          <h1 className="pdg-serif text-4xl sm:text-5xl text-foreground max-w-3xl leading-[1.08]">A considered process</h1>
          <p className="mt-6 text-lg text-foreground/80 max-w-2xl leading-8">
            Four stages, from first contact to completion. No shortcuts, no noise.
          </p>
        </Reveal>
        <div className="mt-16 relative">
          <div className="absolute left-[27px] top-2 bottom-2 w-px bg-[hsl(var(--pdg-gold)/0.25)] hidden sm:block" />
          <div className="space-y-8">
            {STEPS.map(([n, t, d], i) => (
              <Reveal key={n} delay={i * 0.05}>
                <div className="flex gap-6">
                  <div className="shrink-0 w-14 h-14 rounded-full border border-[hsl(var(--pdg-gold)/0.4)] flex items-center justify-center pdg-mono text-sm text-[hsl(var(--pdg-gold))] bg-[hsl(var(--background))]">
                    {n}
                  </div>
                  <div className="pt-1 max-w-2xl">
                    <h2 className="pdg-serif text-2xl text-foreground">{t}</h2>
                    <p className="mt-3 text-sm text-muted-foreground leading-7">{d}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
